import * as React from 'react';
import { Form } from 'react-bootstrap';
import { getLocalization } from 'global/global';
import { ModalComponentNames, ModalInterface } from 'Interfaces/ModalInterface';
import { GroupDeleteMode } from 'api/adminApi';
import { deleteAdminGroups } from 'actions/adminGroupActions';
import { setGridSelection } from 'reducers/admin/ui';
import GenericModal from 'views/Modals/GenericModal';
import { useAppDispatch } from 'index';

interface Props {
  ids: number[];
  onClose: () => void;
}

/**
 *  Deleting groups asks what should happen to the data they hold. Replaces
 *  GroupDeleteView.js.
 */
export default function DeleteGroupModal(props: Props) {
  const dispatch = useAppDispatch();
  // The legacy form defaulted to a permanent delete when nothing was picked.
  const [mode, setMode] = React.useState<GroupDeleteMode>('permanent-delete');

  return (
    <GenericModal
      visible
      title={`${getLocalization('deleteAlert')} ${getLocalization('deleteGroup')}`}
      cancel={props.onClose}
      cancelText={getLocalization('cancel')}
      confirmText={getLocalization('ok')}
      onConfirm={() => {
        void dispatch(deleteAdminGroups(props.ids, mode)).then(() => {
          dispatch(setGridSelection([]));
          props.onClose();
        });
      }}
      body={(
        <>
          <p>{getLocalization('groupDelete')}</p>
          <Form.Check
            type="radio"
            id="group-delete-mark"
            name="data-delete"
            label={getLocalization('markDeleted')}
            checked={mode === 'mark-deleted'}
            onChange={() => setMode('mark-deleted')}
          />
          <Form.Check
            type="radio"
            id="group-delete-permanent"
            name="data-delete"
            label={getLocalization('permanentDelete')}
            checked={mode === 'permanent-delete'}
            onChange={() => setMode('permanent-delete')}
          />
        </>
      )}
    />
  );
}

export const showDeleteGroup = (ids: number[]) => {
  const modalProps: ModalInterface<Props> = {
    component: ModalComponentNames.DeleteGroupModal,
    props: {
      ids,
      onClose: () => {
        (window as any).ReactAppBridge.ReduxActions
          .navigateRemoveModal(ModalComponentNames.DeleteGroupModal);
      },
    },
  };
  (window as any).ReactAppBridge.ReduxActions.navigateAddModal(modalProps);
};
